/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import {
  buildNumericFacet,
  buildNumericRange,
  NumericFacet as HeadlessNumericFacet,
  NumericFacet,
  NumericFacetValue,
  SearchEngine
} from '@coveo/headless';
import {getPriceFacetSelected} from "../../../../controllers/facetControllers";
import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { setActiveActionSearchBox, setActiveClearValueInputPrice, setIsNoResultByFilterPrice } from '../../../../actions/searchBoxAction';

interface NumericFacetProps {
  title: string,
  field?: string,
  valueStart: number;
  valueEnd: number;
  delimiter?: string;
  controller: HeadlessNumericFacet;
  format: (n: number) => string;
  facetDeSelect?: any;
  pillProSelected?: any;
  pillConsumerSelected?: any;
  pillBusinessSelected?: any;
  optionField: string;
  isAffiliate: boolean;
  engine: SearchEngine;
}
let CheckboxPrice: FunctionComponent<any> = (props) => {
  const { controller } = props;
  const [state, setState] = useState(controller.state);
  const [show, setShow] = useState(false);
  const [fieldBuildPriceRange, setFieldBuildPriceRange] = useState(props.optionField);
  var [numberMin, setnumberMin] = useState(0);
  var [numberMax, setnumberMax] = useState(numberMin);
  const [selectedInput, setSelectedInput] = useState(false);  //State select input
  const [inputState, setInputState] = useState(controller);
  const [inputFacet, setInputFacet] = useState({
    start: -1,
    end: -1,
  });
  let isMobileView = window.innerWidth < 768;
  let isSkip = false;
  const dispatch = useDispatch();
  let PriceRange: NumericFacet;
  let refff = useRef(props.controller);
  useEffect(() => {
    controller.subscribe(() => {
      // ignore value number of result less than 0
      if(controller.state.values.length > 0){
        const ingoreNumberOfResultZero = controller.state.values.filter((value : NumericFacetValue , index: number) =>   value.numberOfResults > 0 && value.end > 0)
        setState({...controller.state, values:ingoreNumberOfResultZero })
      }
    });
  },
    [controller.state.values, show]);
  useEffect(() => {
    if(props.isActiveClearValueInputPrice){
      setnumberMin(0);
      setnumberMax(0);
      dispatch(setActiveClearValueInputPrice({value : false}))
    }
  },
    [props.isActiveClearValueInputPrice]);
  useEffect(() => {
    const startPriceEle = document.getElementById("startPrice") as HTMLInputElement;
    const endPriceEle = document.getElementById("endPrice") as HTMLInputElement;
    const filterSectionEl = document.querySelector('.breadcrumb-header');
    let maxValue;
    if (refff.current.state.values.length) {
      maxValue = refff.current.state.values.reduce((max : any, next: any) => {
        return next.end > max.end ? next : max;
      });
    }
    if (startPriceEle?.value == "" && endPriceEle?.value == "") {
      return
    }
    let startPrice = Number(startPriceEle?.value === "" ? "-1" : Number(startPriceEle?.value).toFixed(2));
    let endPrice = Number(endPriceEle?.value === "" ? maxValue?.end + 1: Number(endPriceEle?.value).toFixed(2));
    let startPriceVal = startPriceEle?.value;
    let endPriceVal = endPriceEle?.value;

    // Set data-start/data-end price input value to filter section to use in case no result returns
    filterSectionEl?.setAttribute('startPrice', startPriceVal);
    filterSectionEl?.setAttribute('endPrice', endPriceVal);

    if (selectedInput && (startPrice || startPrice===0) && (endPrice || endPrice ===0)) {
      if (
          (startPriceEle?.value == "0" && endPriceEle?.value == "") ||
          (endPriceEle?.value == "0" && startPriceEle?.value == "") ||
          (startPrice > endPrice && endPriceEle?.value !== "" && startPriceEle?.value !== "")
      ) {
        dispatch(setActiveClearValueInputPrice({value : true}));
        dispatch(setIsNoResultByFilterPrice(true));
        setSelectedInput(false);
        return;
      } else if (startPrice === endPrice) {
        endPrice = endPrice + 1;
      }
      if (startPriceEle?.value != "") {
        setnumberMin(startPrice);
      }
      if (endPriceEle?.value != "") {
        setnumberMax(endPrice);
      }
      // created one facet price new
      // eslint-disable-next-line react-hooks/exhaustive-deps
      let valueAdded = refff.current.state.values.filter((item : any) => item.start == startPrice && item.end == endPrice);
      if (valueAdded.length > 0 || (inputFacet.start == startPrice && inputFacet.end == endPrice)) {
        if (!refff.current.isValueSelected(valueAdded[0])) {
          dispatch(setActiveActionSearchBox(false));
          refff.current.toggleSelect(valueAdded[0]);
        }
        setSelectedInput(false);
        return;
      }
      setInputFacet({start: startPrice, end: endPrice});
      dispatch(setActiveActionSearchBox(false));
      let newValue = refff.current.state.values.filter((item : any) => !(item.start == inputFacet.start && item.end == inputFacet.end))
      let currents = [buildNumericRange({ start: startPrice, end: endPrice, state: "selected"}),
        ...newValue];
      PriceRange = buildNumericFacet(props.engine, {
        options: {
          field: `${fieldBuildPriceRange}`,
          generateAutomaticRanges: false,
          currentValues: [ // Must be specified when `generateAutomaticRanges` is false.
              ...currents
          ],
          //  injectionDepth: 2000,
        },
      });
      // PriceRange.deselectAll();
      setInputState(PriceRange);
    }
    else {
      if (selectedInput) {
        if (!startPrice  && startPrice!==0) {
          document.getElementById("startPrice")?.focus();
          setSelectedInput(false);
        }
        else if (!endPrice  && endPrice!==0) {
          document.getElementById("endPrice")?.focus();
          setSelectedInput(false);
        }
      }
    }
  }, [selectedInput]);
  useEffect(()=>{
    if(inputState !== controller){
      //Deselect all from Price range old and check condition if refff is controller -> no deselecall
      // if(refff.current !== controller){
      refff.current.deselectAll();
      // }
      //Assignment pricerange when effect for next render
      refff.current = inputState;
      let values = refff.current.state.values.filter((item : any) => item.state == "selected");
      let showMessage = false;
      if(values.length > 0){
        // first one deselect all facet price after create or selected
        //   inputState.toggleSelect(inputState.state.values[0]);
        values.map((value: any) => {
          dispatch(setIsNoResultByFilterPrice(false));
          if (value.numberOfResults > 0) {
            inputState.toggleSelect(value);
          } else if (value.start == inputFacet.start && value.end == inputFacet.end) {
            dispatch(setActiveClearValueInputPrice({value : true}));
            dispatch(setIsNoResultByFilterPrice(true));
          }
        })
      }
      setSelectedInput(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputState, inputState === controller ? undefined : inputState.state.values.length])

  function getKeyForRange(value: NumericFacetValue) {
    return `[${value.start}..${value.end}${value.endInclusive ? ']' : '['}`;
  }
  if (
    !state.values.filter(
      (value: any) => value.state !== 'idle' || value.numberOfResults > 0
    ).length
  ) {
    return <div></div>;
  }
  function getShowLess() {
    return (
      <div
        className="viewless-btn"
        onClick={() => {
          setShow(false);
        }}
      >
        Less
      </div>
    );
  }
  function getShowMore() {
    return (
      <div
        className={"viewmore-btn" + (isMobileView ? " deactive" : "")}
        onClick={() => {
          setShow(true);
        }}
      >
        View More
      </div>
    );
  }
  const { format } = props;
  function expandCollapseAccordion(e: any) {
    var accordion = e.target;
    var children = e.target.nextElementSibling;
    var viewmoreBtn = e.target.closest(".facet-accordion-container").querySelector(".viewmore-btn");
    var viewLessBtn = e.target.closest(".facet-accordion-container").querySelector(".viewless-btn");
    if (!accordion.classList.contains("collapsed")) {
      accordion.classList.add("collapsed");
      children.classList.add("deactive");
      if (viewmoreBtn) {
        viewmoreBtn.classList.add("deactive");
      }
      if (viewLessBtn) {
        viewLessBtn.classList.add("deactive");
      }
    }
    else {
      accordion.classList.remove("collapsed");
      children.classList.remove("deactive");
      if (viewmoreBtn) {
        viewmoreBtn.classList.remove("deactive");
      }
      if (viewLessBtn) {
        viewLessBtn.classList.remove("deactive");
      }
    }
  }

  function selectOptionFacet(value: any) {
    dispatch(setActiveActionSearchBox(false));
    dispatch(setIsNoResultByFilterPrice(false));
    refff.current.toggleSelect(value);

  }
  const handleOnBlur = () => {
    if (window.innerWidth <= 1024 && !!(document.querySelector("#endPrice") as HTMLInputElement).value) {
      setSelectedInput(true);
    }
  };

  const rx_live = /^[+-]?\d*(?:[.,]\d*)?$/;
  const handleDepositeAmountChange = ( option: number ,evt: any ) => {
    if (rx_live.test(evt.target.value)){
      if(option ===1 ){
        setnumberMin(evt.target.value);
      }else {
        setnumberMax(evt.target.value)
      }
    }
  }

  return (
    <div className="facet-type-item">
      <div className="facet-accordion-container">
        <div className="facet-accordion">
          <button
              className={"facet-type" + (isMobileView ? " collapsed":"")}
            onClick={(e) => expandCollapseAccordion(e)}
          >
            {props.title}
          </button>
          <div className={"facet-accordion-children" + (isMobileView ? " deactive":"")}>
            <div className="price-input-section">
              <input
                id="startPrice"
                className="price-input"
                type="text"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                min={0}
                value={numberMin === 0 ? '' : numberMin }
                onKeyDown={(e) => {
                  e.key === "Enter" && setSelectedInput(true);
                  ["+", "-", ","].includes(e.key) && e.preventDefault();
                }}
                onChange={(event) => {
                  handleDepositeAmountChange(1 , event)
                }}
                placeholder="min."
              ></input>
              <p className="pricetoprice-text">to</p>
              <input
                id="endPrice"
                className="price-input"
                type="text"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                min={0}
                value={numberMax === 0? '' : numberMax}
                onKeyDown={(e) => {
                  e.key === "Enter" && setSelectedInput(true);
                  ["+", "-", ","].includes(e.key) && e.preventDefault();
                }}
                onChange={(event) => {
                  handleDepositeAmountChange(2 , event)
                }}
                placeholder="max."
              ></input>
              <button className="price-filter-go" onClick={(e) => {
                e.preventDefault();
                const startPriceEle = document.getElementById("startPrice") as HTMLInputElement;
                const endPriceEle = document.getElementById("endPrice") as HTMLInputElement;
                if (startPriceEle.value == "" && endPriceEle.value == "") {return;}
                setSelectedInput(true);
              }} title="Go">Go</button>
            </div>

            {refff.current.state.values.filter((item : any) => item.numberOfResults > 0).map((value: any, index: number) => {
              if (isSkip || !(inputFacet.start == value.start && inputFacet.end == value.end)) {
                return (
                    <div className="facet-child" key={getKeyForRange(value)}>
                      <div>
                        <input
                            type="checkbox"
                            checked={controller.isValueSelected(value)}
                            onChange={() => selectOptionFacet(value)}
                            disabled={state.isLoading}
                            id={`price-${index}`}
                        />
                        <label className="facet-label" htmlFor={`price-${index}`}>
                          <div className="label">
                            {value.start > 0 ? format(value.start) + " - ": "Under "} {format(value.end)}{" "}
                          </div>
                        </label>
                      </div>
                    </div>
                );
              } else {
                isSkip = true;
              }
            })}
          </div>
          <div className="facet-value-selected">{getPriceFacetSelected(props.controller, format)}</div>
        </div>
      </div>
    </div>
  );
};
CheckboxPrice = connect((state: any, ownProps) => {
  return {
    ...ownProps,
    isActiveClearValueInputPrice: state.searchBoxReducer.isActiveClearValueInputPrice,
    actionSearchBox: state.searchBoxReducer.actionSearchBox,
    searchClearFilter: state.searchBoxReducer.searchClearFilter
  };
})(CheckboxPrice);

export default CheckboxPrice;